export const GET_RECOMMEND_TEACHER='GET_RECOMMEND_TEACHER';


// WEBPACK FOOTER //
// ./src/redux/type/RecommendTeacher.type.js